import { useState } from 'react'
import type { User } from '../api/types'
import { initials, toneFor } from '../lib/format'

interface AvatarProps {
  user?: User | null
  /** Used when there is no user (channels, unknown users). */
  name?: string
  id?: string
  online?: boolean
  className?: string
  variant?: 'person' | 'channel'
  title?: string
  /** Pointer shortcut (e.g. a bot's profile). Keep a keyboard-accessible control for the same action elsewhere. */
  onClick?: () => void
}

export function Avatar({ user, name, id, online, className, variant = 'person', title, onClick }: AvatarProps) {
  const [failed, setFailed] = useState(false)
  const label = user?.displayName ?? name ?? '?'
  const tone = variant === 'channel' ? 'channel' : toneFor(user?.id ?? id ?? label)
  const classes = ['avatar', tone, online ? 'online' : '', onClick ? 'clickable' : '', className ?? ''].filter(Boolean).join(' ')
  const src = user?.avatarUrl && !failed ? user.avatarUrl : null
  return (
    <span className={classes} title={title} aria-hidden="true" onClick={onClick}>
      {src ? <img src={src} alt="" loading="lazy" onError={() => setFailed(true)} /> : initials(label)}
    </span>
  )
}
